/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Pump_SendingInputs */

const vi_irrigation_pump_sending = /** @type {(inputs: Irrigation_Pump_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang gửi…`)
};

/**

* @param {Irrigation_Pump_SendingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_pump_sending = /** @type {((inputs?: Irrigation_Pump_SendingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Pump_SendingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_pump_sending(inputs)
});